const pdfState = {
  data: {},
  loadTemplate: false,
};

export default pdfState;
